import React from "react";
import premiumBadge from "../../../assets/images/modeLogos/premiumBadge.png";
import normalBadge from "../../../assets/images/modeLogos/normalBadge.png";
import modeDone from "../../../assets/icons/common/modeDone.svg";
const ModeCards = ({ selectedMode, onSelectMode }) => {
  return (
    <div className="w-100 py-[24px] grid grid-cols-1  md:grid-cols-2  gap-[24px]">
      <div
        className={`w-100 p-[24px] bg-white rounded-[16px] border-[1px] relative ${
          selectedMode === "premium" ? "border-[#34BD5A]" : "border-[#F1F5F9]"
        } cursor-pointer`}
        onClick={() => onSelectMode("premium")}
      >
        <img src={normalBadge} alt="" />
        <article className="pt-[12px]">
          <h2 className="text-[20px] font-semibold text-[#334155]">Premium</h2>
          <p className="text-[12px] text-[#64748B]">
            20 dakika süreyle sınırlıdır. Soru başı geçirilen süreler ve doğru /
            yanlış oranı kaydedilir ve genelde puanlanır.
          </p>
        </article>
        <div
          className={`absolute top-[15px] right-[17px] ${
            selectedMode === "premium" ? "block" : "hidden"
          }`}
        >
          <img src={modeDone} alt="" />
        </div>
      </div>
      <div
        className={`w-100 p-[24px] bg-white rounded-[16px] border-[1px] relative ${
          selectedMode === "normal" ? "border-[#34BD5A]" : "border-[#F1F5F9]"
        } cursor-pointer`}
        onClick={() => onSelectMode("normal")}
      >
        <img src={premiumBadge} alt="" />
        <article className="pt-[12px]">
          <h2 className="text-[20px] font-semibold text-[#334155]">Normal</h2>
          <p className="text-[12px] text-[#64748B]">
            Süre sınırsızdır. Soru başı geçirilen süreler ve doğru / yanlış
            oranları sadece sizin göreceğiniz şekilde kaydedilir.
          </p>
        </article>
        <div
          className={`absolute top-[15px] right-[17px] ${
            selectedMode === "normal" ? "block" : "hidden"
          }`}
        >
          <img src={modeDone} alt="" />
        </div>
      </div>
    </div>
  );
};

export default ModeCards;
